import Tooltip from 'bootstrap/js/dist/tooltip'

import {
    isTouchDevice,
} from './module_common';

export function initTooltip(){
    if (!isTouchDevice()){
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
    }
}